// components/SessionHeader.js - VERSION PRESTATIONS
import React from 'react';

/**
 * En-tete de la modal de prestation
 */
const SessionHeader = ({
  editingSession,
  sessionType,
  sessionTypes = [],
  formData = { prestation_type: 'prestation' },
  onClose
}) => {
  const safeFormData = formData || { prestation_type: 'prestation' };
  const safeSessionTypes = sessionTypes || [];
  const currentType = sessionType || safeFormData.prestation_type || safeFormData.session_type;

  const currentSessionType = safeSessionTypes.find(t => t && t.value === currentType) || {
    label: 'Prestation',
    description: 'Prestation de service'
  };

  return (
    <div style={{
      // ✅ RÉDUCTION DRASTIQUE : Padding ultra-compact (16px → 8px max)
      padding: 'clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '20px 20px 0 0',
      // ✅ NOUVEAU : Limiter hauteur maximale
      minHeight: 'clamp(36px, 8vw, 48px)'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '6px',
        flex: 1,
        minWidth: 0 // Pour truncate
      }}>
        {/* ✅ SUPPRESSION : Plus d'icône volumineuse inutile */}
        <h2 style={{ 
          margin: 0, 
          // ✅ RÉDUCTION DRASTIQUE : Taille titre ultra-compacte
          fontSize: 'clamp(14px, 3vw, 16px)', 
          fontWeight: '600',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {editingSession?.id ? 'Modifier' : 'Nouvelle'} {currentSessionType?.label || 'Session'}
        </h2>
        
        {/* ✅ SUPPRESSION : Description inutile qui prend de l'espace */}
        {/* Plus de sous-titre - gain d'espace énorme */}
      </div>
      
      <button
        onClick={onClose}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          borderRadius: '50%',
          // ✅ RÉDUCTION DRASTIQUE : Bouton ultra-compact
          width: '28px',
          height: '28px',
          cursor: 'pointer',
          color: 'white',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease',
          flexShrink: 0
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.3)';
          e.target.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255,255,255,0.2)';
          e.target.style.transform = 'scale(1)';
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default SessionHeader;